import { RichText } from '../../../common/components/rich-text'

import { useStyles } from './text-block.style'

export const TextBlock = function ({ value, style = {} }) {
  const classes = useStyles()

  return (
    <div className={classes.content} style={style}>
      <RichText value={value} />
    </div>
  )
}
